/** SicilyAddict — CRO runtime + regola comunicazione catena del freddo (scheda prodotto).
    20-10-2026: tolte le modifiche al carrello (nota spedizione Rebuy, barra e link nel carrello del tema):
    il carrello torna quello nativo del tema, poi Essential Cart Drawer. */
(function(){
'use strict';
function fixReviewAnchors(root){Array.prototype.forEach.call((root||document).querySelectorAll('a[href$="#product-reviews"]'),function(a){a.href=a.href.replace('#product-reviews','#recensioni');});}
function enhanceProduct(){if(!document.body.classList.contains('template-product'))return;var cold=!!document.querySelector('[data-sa-cold-product="true"]');document.body.classList.toggle('sa-product-cold',cold);document.body.classList.toggle('sa-product-ambient',!cold);if(!cold)Array.prototype.forEach.call(document.querySelectorAll('.sa-assur__ship-list li'),function(li){if(/frozen premium/i.test(li.textContent||''))li.remove();});var where=document.querySelector('.sa-sped__where span:last-child');if(where&&!cold&&!where.dataset.saAmbientFixed){where.innerHTML='<strong>Spedizione Standard al checkout.</strong> Frozen Premium è prevista solo quando nel carrello c’è almeno un prodotto che richiede catena del freddo.';where.dataset.saAmbientFixed='1';}}
function style(){if(document.getElementById('sa-cro-runtime-style'))return;var s=document.createElement('style');s.id='sa-cro-runtime-style';s.textContent='body.template-product:not(.sa-product-cold) .sa-sped__card--frozen{display:none!important}body.template-product:not(.sa-product-cold) .sa-sped__grid{grid-template-columns:1fr!important;max-width:720px}body.template-product:not(.sa-product-cold) .sa-sped__card--std{width:100%}body.template-cart .page__header .page__description{display:none!important}';document.head.appendChild(s);}
function run(){style();fixReviewAnchors(document);enhanceProduct();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
window.addEventListener('pageshow',function(){setTimeout(run,0);});
if('requestIdleCallback'in window)requestIdleCallback(run,{timeout:1400});else setTimeout(run,900);
})();

/* SicilyAddict - accordion della scheda prodotto: se ne apri uno, quello aperto prima si chiude.
   Usa l'evento "collapsible:toggle" del tema (CollapsibleManager), cosi' l'animazione resta la stessa. */
(function(){
  'use strict';
  var SEL='.product-block-list__item--content .card__collapsible-button[data-action="toggle-collapsible"]';
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest(SEL);
    if(!btn||btn.getAttribute('aria-expanded')==='true')return;
    document.querySelectorAll(SEL+'[aria-expanded="true"]').forEach(function(open){
      if(open===btn)return;
      document.dispatchEvent(new CustomEvent('collapsible:toggle',{detail:{id:open.getAttribute('aria-controls')}}));
    });
  },true);
})();

/* SicilyAddict - "Leggi di piu'" sempre presente sui testi lunghi.
   Il tema controlla i blocchi .expandable-content solo al caricamento: quando la scheda prodotto
   si ridisegna (cambio variante, rendering parziale) il testo restava tagliato senza pulsante.
   Qui il controllo si ripete quando cambia la pagina (idempotente). */
(function(){
  'use strict';
  function check(){
    document.querySelectorAll('.expandable-content[data-expanded="false"]:not(.expandable-content--expandable)').forEach(function(el){
      if (el.scrollHeight > el.clientHeight + 2) el.classList.add('expandable-content--expandable');
    });
  }
  var t;
  function later(){ clearTimeout(t); t = setTimeout(check, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  window.addEventListener('load', later);
  var main = document.getElementById('main') || document.querySelector('main');
  if (main) new MutationObserver(later).observe(main, { childList: true, subtree: true });
})();

/* SicilyAddict - galleria della scheda prodotto su mobile: puntini al posto delle miniature.
   I puntini usano le miniature del tema (nascoste via CSS): un tocco sul puntino = tocco sulla
   miniatura, cosi' il carosello resta quello del tema. Il puntino attivo segue la foto visibile. */
(function(){
  'use strict';
  function build(gallery){
    var thumbs = gallery.querySelectorAll('.product-gallery__thumbnail');
    var items = gallery.querySelectorAll('.product-gallery__carousel-item');
    var old = gallery.querySelector('.sa-gallery-dots');
    if (thumbs.length < 2 || !items.length) { if (old) old.remove(); return; }
    if (old && old.dataset.count === String(thumbs.length)) return;
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.className = 'sa-gallery-dots';
    wrap.dataset.count = String(thumbs.length);
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Foto del prodotto');
    Array.prototype.forEach.call(thumbs, function(th, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sa-gallery-dots__dot';
      b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' di ' + thumbs.length);
      b.addEventListener('click', function(){ th.click(); });
      wrap.appendChild(b);
    });
    var carousel = gallery.querySelector('.product-gallery__carousel');
    (carousel && carousel.parentNode === gallery ? carousel : gallery.firstElementChild).insertAdjacentElement('afterend', wrap);
    sync(gallery);
  }
  function sync(gallery){
    var wrap = gallery.querySelector('.sa-gallery-dots'); if (!wrap) return;
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__carousel-item'));
    var idx = items.findIndex(function(it){ return it.classList.contains('is-selected'); });
    if (idx < 0) idx = 0;
    Array.prototype.forEach.call(wrap.children, function(d, i){
      var on = i === idx;
      if (d.classList.contains('is-active') !== on) d.classList.toggle('is-active', on);
      if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
  }
  function init(){
    document.querySelectorAll('.product-gallery').forEach(function(g){
      build(g);
      if (g.dataset.saDots === '1') return;
      g.dataset.saDots = '1';
      var raf = 0;
      new MutationObserver(function(){
        if (raf) return;
        raf = requestAnimationFrame(function(){ raf = 0; build(g); sync(g); });
      }).observe(g, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('variant:change', function(){ setTimeout(init, 150); });
  var main = document.getElementById('main') || document.querySelector('main');
  if (main) new MutationObserver(function(){ setTimeout(init, 150); }).observe(main, { childList: true });
})();

/* SicilyAddict 10/2026 - Accessibilita' nel footer.
   L'icona flottante del widget accessibilita' di Iubenda (in basso a sinistra) e' nascosta (sa-cro.css);
   il link "Accessibilita'" nel footer, accanto alle preferenze privacy, apre lo stesso pannello
   premendo il pulsante originale. Il widget si carica dopo la pagina: si aspetta fino a 4 s. */
(function () {
  function awButton() { return document.querySelector('.iub-floatable-wrapper-aw-2025 button, .iubenda-floatable-aw-btn'); }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.sa-a11y-link');
    if (!link) return;
    e.preventDefault();
    var tries = 0;
    (function open() {
      var b = awButton();
      if (b) { b.click(); return; }
      if (++tries < 20) setTimeout(open, 200);
    })();
  });
})();

/* SA velocità (dalla bozza SEO 18/10): la seconda foto delle card si scarica solo al primo passaggio del mouse; su touch mai. */
(function(){"use strict";function prepare(event){if(!window.matchMedia||!window.matchMedia("(hover: hover)").matches)return;var wrapper=event.target&&event.target.closest?event.target.closest("[data-sa-card-hover]"):null;if(!wrapper||wrapper.dataset.saHoverState)return;var image=wrapper.querySelector("img[data-sa-hover-src]");if(!image)return;wrapper.dataset.saHoverState="loading";function cleanup(){image.removeEventListener("load",loaded);image.removeEventListener("error",failed)}function loaded(){if(!image.naturalWidth||(image.currentSrc||image.src).indexOf("data:")===0)return;cleanup();wrapper.dataset.saHoverState="ready";wrapper.classList.add("product-item__image-wrapper--with-secondary")}function failed(){cleanup();wrapper.dataset.saHoverState="error"}image.addEventListener("load",loaded);image.addEventListener("error",failed);image.loading="eager";if(image.dataset.saHoverSrcset)image.srcset=image.dataset.saHoverSrcset;image.src=image.dataset.saHoverSrc}document.addEventListener("pointerover",prepare,{passive:true});document.addEventListener("focusin",prepare)})();

/* SA 21-10-2026: il carrello Essential cambia le quantità senza avvisare il tema, quindi il numerino sull'icona
   del carrello restava fermo. A ogni modifica del carrello (add/change/update/clear) si rilegge /cart.js e si aggiorna. */
(function () {
  'use strict';
  if (!window.PerformanceObserver || !window.fetch) return;
  var timer = null;
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function refreshCount() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.header__cart-count').forEach(function (el) {
            if (el.textContent !== String(cart.item_count)) el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }, 120);
  }
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (CART_CHANGE.test(entry.name.split('#')[0])) refreshCount();
      });
    }).observe({ type: 'resource' });
  } catch (e) {}
})();

/* 01-11-2026 (6.8.5) - Header mobile: la ricerca e' ridotta a lente (impostazione "Minimise search on mobile").
   Toccando la lente il tema mostra la barra: il cursore va subito nel campo, cosi' su telefono si apre la tastiera.
   Il focus avviene nello stesso tocco (iOS apre la tastiera solo cosi'): ascolto su window, che nella fase di
   risalita arriva dopo il gestore del tema sul documento, quando la barra e' gia' visibile. */
(function () {
  window.addEventListener('click', function (e) {
    /* "Chiudi" richiude anche la barra sotto l'header (con la lente la barra non deve restare aperta) */
    var close = e.target.closest && e.target.closest('.header [data-action="unfix-search"]');
    if (close) {
      setTimeout(function () {
        var lens = document.querySelector('.header [data-action="toggle-search"]');
        var w = document.querySelector('.header__search-bar-wrapper');
        if (lens && lens.offsetParent && w && w.classList.contains('is-visible') && !w.classList.contains('is-fixed')) lens.click();
      }, 0);
      return;
    }
    var btn = e.target.closest && e.target.closest('.header [data-action="toggle-search"]');
    if (!btn) return;
    var wrap = document.querySelector('.header__search-bar-wrapper');
    var input = wrap && wrap.querySelector('.search-bar__input');
    if (input && wrap.classList.contains('is-visible')) {
      /* la barra entra con una transizione su visibility: al primo istante e' ancora nascosta e non accetta il focus */
      wrap.style.transition = 'none';
      wrap.style.visibility = 'visible';
      input.focus();
      wrap.style.visibility = '';
      wrap.style.transition = '';
    }
  });
})();
